import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import typography from '../../../../styling/mixins/typography';
import colors from '../../../../styling/colors';

import MagnifyingGlass from '../../../../assets/svg/MagnifyingGlass';

const Container = styled.div`
  height: 2.5rem;
  display: flex;
  justify-content: flex-end;
`;

const Input = styled.input`
  ${typography.BasisFont};
  background: none;
  border: none;
  width: 100%;
  font-size: 1rem;

  &:focus {
    outline: none;
  }

  ::-webkit-search-cancel-button {
    display: none;
  }

  ::placeholder {
    color: ${colors('silver')};
  }
`;

const SearchIcon = styled.div`
  display: inline;
  margin: 0.5rem 0.75rem;
`;

const ClearButton = styled.div`
  ${typography.BasisFont};
  color: ${colors('silver')};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 0.5rem;
  font-size: 0.875rem;
`;

export default class SearchInput extends Component {
  static propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onClear: PropTypes.func,
    onChange: PropTypes.func,
  };

  render() {
    const { value, placeholder, onClear, onChange } = this.props;

    const clearButton = <ClearButton onClick={onClear}>clear</ClearButton>;

    return (
      <Container>
        <SearchIcon>
          <MagnifyingGlass />
        </SearchIcon>
        <Input
          type="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoFocus
        />
        {value.length ? clearButton : ''}
      </Container>
    );
  }
}
